import { render } from "./Spinner.vue?vue&type=template&id=15f5354e&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=15f5354e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f5354e"]])

export default __exports__